import { useState } from "react";
import "./CSS_styles/contact3d.css";

export default function Contact3D() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const emailApiUrl = process.env.REACT_APP_EMAIL_API_URL || "/api/send-email";

  const handleSend = async () => {
    if (!name || !email || !message) {
      alert("Please fill in all fields");
      return;
    }

    setLoading(true);

    try {
      const res = await fetch(emailApiUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, email, message })
      });

      const data = await res.json();

      if (data.status === 'sent') {
        alert("Email sent! 🎉");
        setName("");
        setEmail("");
        setMessage("");
      } else {
        alert("Error sending email");
      }
    } catch (error) {
      alert("Error sending email: " + error.message);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="contact3d-section" data-section="contact">
      <div className="contact3d-stage">
        <div className="contact3d-header">
          <h2 className="contact3d-title">Get in touch!</h2>
          <p className="contact3d-subcopy">
            Ideas, collaborations, experiments, or just a good conversation.
          </p>
          <p className="contact3d-subcopy">
            Quickest way to contact: LinkedIn or fill out the form below and click "Send Message".
          </p>
        </div>

        <div className="contact3d-layout">
          <div className="contact3d-left">
            <a className="contact3d-card contact3d-float-a" href="mailto:arkind12345@gmail.com">
              <div className="contact3d-card-face">
                <span className="contact3d-icon">✉️</span>
                <span className="contact3d-label">Email</span>
              </div>
              <div className="contact3d-card-depth" />
            </a>

            <a
              className="contact3d-card contact3d-float-b"
              href="https://www.linkedin.com/in/ar5sde/"
              target="_blank"
              rel="noreferrer"
            >
              <div className="contact3d-card-face">
                <span className="contact3d-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 24 24">
                    <path
                      fill="#0077b5"
                      d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
                    />
                  </svg>
                </span>
                <span className="contact3d-label">LinkedIn</span>
              </div>
              <div className="contact3d-card-depth" />
            </a>
          </div>

          <div className="contact3d-right">
            <div className="contact3d-form-shell contact3d-float-main">
              <div className="contact3d-form-face">
                <div className="contact3d-form">
                  <div className="contact3d-form-group">
                    <label className="contact3d-form-label">Your Name</label>
                    <input
                      className="contact3d-input"
                      type="text"
                      placeholder="e.g., Abc Carter"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="contact3d-form-group">
                    <label className="contact3d-form-label">Your Email</label>
                    <input
                      className="contact3d-input"
                      type="email"
                      placeholder="e.g.,abc@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <div className="contact3d-form-group">
                    <label className="contact3d-form-label">Your Message</label>
                    <textarea
                      className="contact3d-input contact3d-textarea"
                      placeholder="Hey, I'd love to connect..."
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      disabled={loading}
                    />
                  </div>

                  <button 
                    className="contact3d-submit" 
                    onClick={handleSend}
                    disabled={loading}
                  >
                    <span className="contact3d-submit-face">
                      {loading ? "Sending..." : "Send Message"}
                    </span>
                  </button>
                </div>
              </div>

              <div className="contact3d-form-depth" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
